import { connect } from 'react-redux';
import { ManageUsersComponent } from './manage-users.component';
import { AppState } from '../../app.state';

export const ManageUsers = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageUsersComponent as any
) as unknown as typeof ManageUsersComponent;
